// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__EwLlm","left":"Virtual_left__+kahN","wrapper":"Virtual_wrapper__DsQzc"};